import IconButton from '@mui/joy/IconButton'
import Edit from '@mui/icons-material/Edit'

export const EditButton = ({ onClick }) => (
    <IconButton variant="outlined" color="primary" onClick={onClick}>
        <Edit />
    </IconButton>
)
